export const getSubscriptionState = ({ subscription }) => (
  subscription.get('subscription').get('state')
)

export const getShouldClosePauseReasonsView = ({ onScreenRecovery }) => onScreenRecovery.getIn(['subscriptionPause', 'triggered']) === true
